{
  "header": "Szczegóły zasobu",
  "subtitle": "Zasób dołączony do Twojego pojazdu (naczepa, kontener itp.).",
  "assetType": "Typ zasobu",
  "assetTypePlaceholder": "Wybierz typ zasobu",
  "assetId": "ID zasobu (np. numer naczepy)",
  "assetIdPlaceholder": "Np.: numer naczepy, ID kontenera itp.",
  "remove": "Usuń",
  "addAnother": "Dodaj kolejny zasób",
  "trailerType": "Typ naczepy",
  "trailerId": "ID naczepy"
}
